<template>
  <div class="rounded shadow-xs">
    <div class="rounded bg-white shadow-lg overflow-hidden">
      <ValidationObserver ref="observer" v-slot="{ invalid, handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="p-4 lg:p-6 bg-gray-100">
            <h3 class="text-lg">Delete Project</h3>
          </div>
          <div class="p-4 lg:p-6 space-y-4 lg:space-y-6">
            <ValidationProvider :rules="{ required: { allowFalse: false } }" tag="div">
              <template #default>
                <BaseFormGroup class="max-w-lg">
                  <BaseFormCheckbox
                    id="name"
                    v-model="confirmed"
                    label="I understand that once I delete this project, there is no going back"
                    :disabled="isPending"
                  />
                </BaseFormGroup>
              </template>
            </ValidationProvider>
          </div>
          <div class="p-4 lg:p-6">
            <BaseButton :danger="isIdle || isPending" :disabled="invalid">
              <span v-if="isIdle">Delete</span>
              <span v-else-if="isPending">Please wait...</span>
              <span v-else-if="isResolved">Success!</span>
              <span v-else>Failed!</span>
            </BaseButton>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import veeValidateErrorsMixin from '@/mixins/veeValidateErrorsMixin';

export default {
  name: 'DeleteProjectForm',

  mixins: [veeValidateErrorsMixin],

  props: {
    project: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      confirmed: false,
      status: 'idle',
    };
  },

  computed: {
    isIdle() {
      return this.status === 'idle';
    },
    isPending() {
      return this.status === 'pending';
    },
    isResolved() {
      return this.status === 'resolved';
    },
    isRejected() {
      return this.status === 'rejected';
    },
  },

  methods: {
    async onSubmit() {
      if (!this.isIdle) {
        return;
      }
      this.setPending();
      try {
        await this.$store.dispatch({
          type: 'ui/projects/destroy',
          projectUuid: this.project.uuid,
        });

        this.$router.replace({
          name: 'accounts.projects',
          params: { accountId: this.$route.params.accountId },
        });
        this.setResolved();
      } catch (error) {
        this.setRejected();
      } finally {
        setTimeout(() => {
          this.setIdle();
        }, 1500);
      }
    },
    setIdle() {
      this.status = 'idle';
    },
    setPending() {
      this.status = 'pending';
    },
    setResolved() {
      this.status = 'resolved';
    },
    setRejected() {
      this.status = 'rejected';
    },
  },
};
</script>
